import { useState } from "react";
import { socket as mockSocket } from "utils/socket";

// Custom hook returning mock socket state
const useSocket = () => {
  const [socketConnect] = useState(true);
  const [socket] = useState(mockSocket);

  return { socket, socketConnect };
};

export default useSocket;
